<template>
  <div id="homePage">
    <template v-if="showContent">
      <Cover></Cover>
      <LastestNews :news="news"></LastestNews>
      <HomeContent :data="history"></HomeContent>
      <HomeContent :data="story"></HomeContent>
      <Contact :data="contact"></Contact>
      <!-- Modal -->
      <div class="modal container" :class="{'show': showModel }" @click="closeModel">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body d-flex align-items-center justify-content-center p-3">
              <img class="img-fluid-custom" :src="`/${this.$staticPath}/images/Artboard.jpg`">
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Cover from './Cover.vue'
import LastestNews from './LastestNews.vue'
import HomeContent from './Content.vue'
import Contact from './Contact.vue'

export default {
  components: {
    Cover,
    LastestNews,
    HomeContent,
    Contact
  },
  data () {
    return {
      news: {},
      history: {},
      story: {},
      contact: {},
      showContent: false,
      showModel: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var history = await import('../../json/en/home/history.json')
        var story = await import('../../json/en/home/story.json')
        var contact = await import('../../json/en/home/contact.json')
        var news = await import('../../json/en/home/news.json')
      } else {
        history = await import('../../json/th/home/history.json')
        story = await import('../../json/th/home/story.json')
        contact = await import('../../json/th/home/contact.json')
        news = await import('../../json/th/home/news.json')
      }

      this.news = news
      this.history = history
      this.story = story
      this.contact = contact
      this.showContent = true
      this.showModel = true
    },

    closeModel () {
      this.showModel = false
    }
  }
}
</script>
<style scoped>
.modal-dialog{
  position: relative;
  display: table;
  overflow-y: auto;
  overflow-x: auto;
  min-width: fit-content;
}

.img-fluid-custom {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/HOME/Index.vue